import { Select } from 'antd'
import { getStorageLocationId, updateLocationId, useTranslate } from 'utils'
import { useRef, useState } from 'react'
import { Loading, NotFound, PageError } from 'components/styled'
import { useCurrentLocation, useLocations } from 'api'
import { DEBOUNCING_TIMEOUT } from 'app.constants'
import { useLocation, useNavigate } from 'react-router-dom'

export const LocationSelector = () => {

    const storageLocationId = getStorageLocationId()

    //debounce timeout:
    const lastKeyPressTimeoutId = useRef(0 as number | NodeJS.Timeout)

    //hooks:
    const { __ } = useTranslate()
    const navigate = useNavigate()
    const windowLocation = useLocation()
    
    //state:
    const [ search, setSearch ] = useState<string | null>(null)
    const [ isTyping, setIsTyping ] = useState(false)

    //api:
    const { data: currentLocation } = useCurrentLocation()
    const {
        data: locations,
        isLoading: isLocationsLoading,
        isFetching: isLocationFetching,
        isError: isLocationsError
    } = useLocations(search, 5)

    //search locations
    const searchLocations = (searchPhrase: string) => {
        setIsTyping(true)
        clearTimeout(lastKeyPressTimeoutId.current)
        if(searchPhrase.length < 1){
            setSearch(null)
            setIsTyping(false)
        }else{
            lastKeyPressTimeoutId.current = setTimeout(() => {
                setSearch(searchPhrase)
                setIsTyping(false)
            }, DEBOUNCING_TIMEOUT)
        }
    }

    const allLocations = windowLocation.pathname.includes('/appointments') ? {
        id: 'all',
        name: __`all_locations`
    } : null

    return (locations && storageLocationId !== null) ? (
        <Select
            options={
                (search ? locations : (
                    (
                        allLocations ? [allLocations] : []
                    ).concat(
                        currentLocation ? [currentLocation] : []
                    ).concat(
                        locations.filter(l => currentLocation ? l.id !== currentLocation.id : true)
                    )
                )).map(l => ({ value: l.id, label: l.name }))
            }
            value={storageLocationId}
            showSearch
            onSearch={searchLocations}
            filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
            onChange={value => {
                updateLocationId(value)
                navigate(location.pathname)
            }}
            notFoundContent={
                (isLocationsLoading || isLocationFetching || isTyping) ? <Loading/> :
                isLocationsError ? <PageError message={__`error`}/> :
                <NotFound message={search ? undefined : __`no_locations`}/>
            }
            style={{ width: '100%' }}
        />
    ) : <></>
}
